import React, { Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PrinterIcon, ArrowLeftIcon } from 'lucide-react';
import { FormSection, DisplayField } from '../components/FormComponents';
import { mockQCEntries } from '../data/mockData';
export function GRNReport() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const data = mockQCEntries.find(q => q.id === id && q.qcStatus === 'Passed');
  if (!data) {
    return <div className="flex flex-col items-center justify-center h-64 space-y-4" data-id="element-1054">
        <p className="text-gray-500" data-id="element-1055">GRN Record not found or QC not passed.</p>
        <button onClick={() => navigate('/grn')} className="text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-1056">
          Return to GRN List
        </button>
      </div>;
  }
  const grnNo = data.qcReferenceNo.replace('QC-', 'GRN-');
  return <div className="space-y-6 max-w-4xl mx-auto" data-id="element-1057">
      {/* Action Buttons - Hidden when printing */}
      <div className="flex items-center justify-between print:hidden" data-id="element-1058">
        <button onClick={() => navigate(-1)} className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-1059">
          <ArrowLeftIcon className="h-4 w-4 mr-1" data-id="element-1060" /> Back
        </button>
        <button onClick={() => window.print()} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1061">
          <PrinterIcon className="h-4 w-4 mr-2" data-id="element-1062" /> Print GRN
        </button>
      </div>

      {/* Printable Document Area */}
      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-8 md:p-12 print:shadow-none print:border-none print:p-0" data-id="element-1063">
        {/* Document Header */}
        <div className="border-b border-gray-200 pb-6 mb-8 flex justify-between items-start" data-id="element-1064">
          <div data-id="element-1065">
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-1066">
              Procurement System
            </h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-1067">
              123 Business Avenue, Tech District, 10001
            </p>
          </div>
          <div className="text-right" data-id="element-1068">
            <h2 className="text-2xl font-bold text-indigo-600 uppercase tracking-wider" data-id="element-1069">
              Goods Received Note
            </h2>
            <p className="text-sm font-medium text-gray-900 mt-1" data-id="element-1070">{grnNo}</p>
            <p className="text-sm text-gray-500" data-id="element-1071">
              Date: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>

        <div className="space-y-8" data-id="element-1072">
          {/* Section 1: GRN Details */}
          <FormSection title="GRN Details" data-id="element-1073">
            <DisplayField label="GRN No" value={grnNo} data-id="element-1074" />
            <DisplayField label="QC Reference" value={data.qcReferenceNo} data-id="element-1075" />
            <DisplayField label="Inspection Date" value={data.inspectionDate} data-id="element-1076" />
            <DisplayField label="QC Inspector" value={data.qcInspector} data-id="element-1077" />
            <DisplayField label="Warehouse" value={data.warehouse} data-id="element-1078" />
            <DisplayField label="Status" value={<span className="text-green-600 font-bold uppercase tracking-wide text-sm" data-id="element-1080">
                  {data.qcStatus}
                </span>} data-id="element-1079" />
          </FormSection>

          {/* Section 2: Receive Information */}
          <FormSection title="Receive Information" data-id="element-1081">
            <DisplayField label="Receive No" value={data.linkedReceiveNo} data-id="element-1082" />
            <DisplayField label="PO No" value={data.linkedPONo} data-id="element-1083" />
            <DisplayField label="Vendor" value={data.vendor} data-id="element-1084" />
            <DisplayField label="PO Quantity" value={data.poQty} data-id="element-1085" />
            <DisplayField label="Received Quantity" value={<span className="text-blue-600 font-bold" data-id="element-1087">
                  {data.receiveQty}
                </span>} data-id="element-1086" />
          </FormSection>

          {/* Section 3: Item List */}
          <div data-id="element-1088">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-200 pb-2" data-id="element-1089">
              Item List
            </h3>
            <div className="overflow-x-auto" data-id="element-1090">
              <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg" data-id="element-1091">
                <thead className="bg-gray-50" data-id="element-1092">
                  <tr data-id="element-1093">
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-1094">
                      #
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-1095">
                      Product
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-1096">
                      Description
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-1097">
                      Type
                    </th>
                    <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-1098">
                      Quantity
                    </th>
                    <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-1099">
                      Rate
                    </th>
                    <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-1100">
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1101">
                  <tr data-id="element-1102">
                    <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1103">1</td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-1104">
                      {data.product}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600" data-id="element-1105">
                      Standard supply as per PO {data.linkedPONo}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600" data-id="element-1106">Goods</td>
                    <td className="px-4 py-3 text-sm text-gray-900 text-right" data-id="element-1107">
                      {data.acceptedQty}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900 text-right" data-id="element-1108">
                      -
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900 text-right" data-id="element-1109">
                      -
                    </td>
                  </tr>
                </tbody>
                <tfoot className="bg-gray-50" data-id="element-1110">
                  <tr data-id="element-1111">
                    <td colSpan={4} className="px-4 py-3 text-sm font-semibold text-gray-900 text-right" data-id="element-1112">
                      Total
                    </td>
                    <td className="px-4 py-3 text-sm font-bold text-gray-900 text-right" data-id="element-1113">
                      {data.acceptedQty}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900 text-right" data-id="element-1114">
                      -
                    </td>
                    <td className="px-4 py-3 text-sm font-bold text-gray-900 text-right" data-id="element-1115">
                      -
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Section 4: Item Details & QC Results */}
          <FormSection title="Item Details & QC Results" data-id="element-1116">
            <div className="md:col-span-2" data-id="element-1117">
              <DisplayField label="Product/Item" value={data.product} data-id="element-1118" />
            </div>
            <DisplayField label="Total Qty for QC" value={data.quantity} data-id="element-1119" />
            <DisplayField label="Accepted Qty" value={<span className="text-green-600 font-bold text-lg" data-id="element-1121">
                  {data.acceptedQty}
                </span>} data-id="element-1120" />
            <DisplayField label="Rejected Qty" value={<span className="text-red-600 font-bold" data-id="element-1123">
                  {data.rejectedQty}
                </span>} data-id="element-1122" />
          </FormSection>

          {/* Section 3: QC Remarks */}
          <FormSection title="Inspection Remarks" data-id="element-1124">
            <div className="md:col-span-2 bg-gray-50 rounded-md p-4 border border-gray-100" data-id="element-1125">
              <p className="text-sm text-gray-700 whitespace-pre-wrap" data-id="element-1126">
                {data.qcRemarks || 'No remarks provided.'}
              </p>
            </div>
          </FormSection>

          {/* Section 4: Received & Approved Info */}
          <FormSection title="Authorization" data-id="element-1127">
            <DisplayField label="Received By" value="Store Officer" data-id="element-1128" />
            <DisplayField label="Approved By" value="Quality Manager" data-id="element-1129" />
          </FormSection>
        </div>

        {/* Document Footer */}
        <div className="mt-16 pt-6 border-t border-gray-200 text-center" data-id="element-1130">
          <p className="text-xs text-gray-400" data-id="element-1131">
            This is a system-generated document. No physical signature is
            required for internal processing.
          </p>
        </div>
      </div>
    </div>;
}